import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import ab from '../assets/images/about-head.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const Aboutus = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${ab})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					About Arya Aviation
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					A technology service provider of new world
				</h6>
			</div>

			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Arya Aviation Adventure Starts Now
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								Started in 2015, Arya Aviation is a part of the R Arya Aviation
								India PVT LTD. The Company is based in the bustling metropolis
								of Hyderabad, Telangana (India). Arya Aviation have a wide
								experience of working with clients across industries globally.
								Over these years, our main focus is in helping clients in
								achieving their goals through their websites/portals.
							</p>
							<br />
							<p>
								At Arya Aviation, we go beyond the surface to delve into what
								you actually need, where you lack and guide you right through
								the process of ideation and creation. We help you visualize and
								finally achieve a seamless transition from IDEA to PRODUCT.
							</p>

							<br />
							<p>
								We are delivering white label solution, Mobile Apps, B2C / B2B
								Travel Software, Travel CRM, Real Estate Portal, Health /
								Medical Apps, Food Ordering Apps, Payment Gateway Integration,
								Car / Bus Rental Software, Hotel Extranet, Holiday Packages and
								more.
							</p>

							<br />
							<p>
								Our main motive is to satisfy your customers with your product
								and simultaneously you achieve growth and success. We develop in
								such a way that your websites attract more and more visitors
								which can be then converted to customers and this will directly
								lead to high revenue. Our client's success is our success and
								our client's satisfaction is our satisfaction.
							</p>

							<br />
							<p>
								We offer a cost-effective way to build/develop and update your
								product, so that you invest with confidence in new product
								development or an update. With us you will not be locked into
								expensive software or web application system because we offer
								maximum flexibility at minimum cost.
							</p>

							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default Aboutus;
